/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Author_ColInputs */

const en_admin_posts_author_col = /** @type {(inputs: Admin_Posts_Author_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Author`)
};

/**
* | output |
* | --- |
* | "Author" |
*
* @param {Admin_Posts_Author_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_author_col = /** @type {((inputs?: Admin_Posts_Author_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Author_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_author_col(inputs)
});
export { admin_posts_author_col as "admin.posts.author_col" }